import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { PageSection } from '../../../Layout';

interface IWorksheetResultsSectionProps {
  heading?: string;
  createWorksheetSelector?: any;
}

let WorksheetResultsSection: React.FC<React.PropsWithChildren<IWorksheetResultsSectionProps>> = ({
  children,
  heading,
  createWorksheetSelector,
}) => {
  const [hasInitialised, setHasInitialised] = useState(false);
  const isChecked = useSelector(createWorksheetSelector('header.IsChecked', false));

  // Automatically scroll to the results section when the worksheet is checked.
  // Only do on first initialisation
  useEffect(() => {
    if (isChecked && !hasInitialised) {
      const worksheetHeaderHeight = document.getElementById('fixed-worksheet-header')?.offsetHeight;
      const targetTop = document.getElementById('results')?.offsetTop;
      const viewport = document.getElementsByClassName('WorksheetPage-Content')[0];
      if (worksheetHeaderHeight && targetTop && viewport) {
        viewport.scrollTo(0, targetTop - worksheetHeaderHeight);
      }
    }
    setHasInitialised(true);
  }, [isChecked, hasInitialised, setHasInitialised]);

  return <PageSection id="results" heading={heading} children={children} />;
};

WorksheetResultsSection = withInjectedProps(WorksheetResultsSection);

export { WorksheetResultsSection };
export default WorksheetResultsSection;
